const pageTitleSwitch = () => {
    let originalTitle = document.title;

    document.addEventListener('visibilitychange', () => {
        if (document.hidden) originalTitle = document.title;
        document.title = document.hidden
            ? 'Kom terug 🧡'
            : originalTitle;
    });
};
export { pageTitleSwitch };